// apps/web/src/admin/AdminLiveOpsView.tsx
import { useEffect, useState } from 'react';
import type { AdminLiveOpsResponse } from '@aslgo/shared';
import { apiAdmin } from './apiAdmin.js';

export function AdminLiveOpsView() {
  const [data, setData] = useState<AdminLiveOpsResponse | null>(null);
  useEffect(() => {
    let live = true;
    async function tick() { try { const d = await apiAdmin.liveOps(); if (live) setData(d); } catch {/*ignore*/} }
    void tick();
    const id = setInterval(tick, 5000);
    return () => { live = false; clearInterval(id); };
  }, []);

  if (!data) return <p>Loading…</p>;
  return (
    <div className="flex flex-col lg:flex-row gap-6">
      <div className="flex-1 space-y-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 rounded border"><div className="text-3xl font-semibold">{data.guidesOnline}</div><div className="text-ink-500 text-sm">Guides online</div></div>
          <div className="p-4 rounded border"><div className="text-3xl font-semibold">{data.learnersOnline}</div><div className="text-ink-500 text-sm">Learners online</div></div>
        </div>

        <table className="w-full text-sm">
          <thead className="text-left text-ink-500"><tr><th>Room</th><th>Started</th><th>Duration</th><th>Minutes</th><th>Participants</th><th>Captioner</th><th></th></tr></thead>
          <tbody>
            {data.activeCalls.map((call) => (
              <tr key={call.sessionId}>
                <td>{call.room}</td>
                <td>{new Date(call.startedAt).toLocaleTimeString()}</td>
                <td>{Math.floor(call.durationSeconds / 60)}m {call.durationSeconds % 60}s</td>
                <td>{call.minutesConsumed}</td>
                <td>{call.participants.map((p) => `${p.displayName} (${p.role})`).join(', ')}</td>
                <td>{call.captionerJoined ? 'joined' : '—'}</td>
                <td>
                  <button className="btn" onClick={async () => {
                    if (window.confirm(`Force-end call in room ${call.room}?`)) {
                      try { await apiAdmin.endCall(call.room); }
                      catch (e: unknown) { window.alert(e instanceof Error ? e.message : String(e)); }
                    }
                  }}>Force end</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <aside className="w-full lg:w-72 shrink-0">
        <div className="p-4 rounded border">
          <div className="font-semibold mb-3">Online now</div>
          <div className="grid grid-cols-2 gap-4">
            <OnlineColumn title="Learners" people={data.onlineLearners ?? []} />
            <OnlineColumn title="Guides"   people={data.onlineGuides ?? []} />
          </div>
        </div>
      </aside>
    </div>
  );
}

function OnlineColumn({ title, people }: { title: string; people: { userId: string; displayName: string }[] }) {
  return (
    <div>
      <div className="text-sm font-medium mb-2">{title} ({people.length})</div>
      {people.length === 0
        ? <div className="text-ink-500 text-sm">None</div>
        : <ul className="space-y-1 text-sm">
            {people.map((p) => <li key={p.userId} className="truncate">{p.displayName}</li>)}
          </ul>}
    </div>
  );
}
